import { ClientPortalPageWithSidebarTemplate } from 'ClientPortal/src/pages/Orders/ClientPortalPageWithSidebarTemplate'
import { OrderSidebar } from 'ClientPortal/src/pages/Orders/OrderSidebar'
import { LoadingSkeleton, PageRowTemplate, tokens } from 'ComponentLibrary'
import { STATIC_APP_PATHS } from 'ClientPortal/src/router/constants'
import { GridLegacy as Grid, Stack } from '@mui/material'
import { getLatestUrlParams } from 'ComponentLibrary/src/hooks/useUrlState'
import { useTranslation } from 'react-i18next'

export const OrderDetailsPageLoading = () => {
    const { t } = useTranslation('pages', { keyPrefix: 'orders.orderDetailsPage' })
    const breadCrumbs = [
        { title: t('allOrders'), link: STATIC_APP_PATHS.orderListPage, params: getLatestUrlParams('client-order-filter') },
        { title: t('title') },
    ]

    return (
        <ClientPortalPageWithSidebarTemplate withMaxWidth breadCrumbs={breadCrumbs} title={t('title')} sidebarComponent={<OrderSidebar />}>
            <Stack direction="column" gap={tokens.SizingSpacing400} marginTop={tokens.SizingSpacing400}>
                <Grid container spacing={tokens.SizingSpacing600}>
                    {[0, 1].map((key) => (
                        <Grid key={key} item xs={6} md={6}>
                            <LoadingSkeleton height="110px" width="100%" variant="rounded" />
                        </Grid>
                    ))}
                </Grid>
                <PageRowTemplate>
                    <>
                        <Stack direction="column" width="100%" gap={tokens.SizingSpacing400}>
                            <Stack direction="column" width="100%" gap={tokens.SizingSpacing150}>
                                <LoadingSkeleton height="36px" width="138px" variant="rounded" />
                                <Stack direction="row" gap={tokens.SizingSpacing400}>
                                    <Stack direction="column" gap={tokens.SizingSpacing150}>
                                        <LoadingSkeleton count={2} height="40px" width="175px" variant="rounded" />
                                    </Stack>
                                    <Stack direction="column" gap={tokens.SizingSpacing150}>
                                        <LoadingSkeleton count={2} height="40px" width="236px" variant="rounded" />
                                    </Stack>
                                </Stack>
                            </Stack>
                            <Stack direction="column" gap={tokens.SizingSpacing150}>
                                <LoadingSkeleton height="36px" width="150px" variant="rounded" />
                                <LoadingSkeleton height="24px" width="260px" variant="rounded" />
                            </Stack>
                            <Stack direction="column" gap={tokens.SizingSpacing150}>
                                <LoadingSkeleton height="36px" width="150px" variant="rounded" />
                                <LoadingSkeleton height="24px" width="240px" variant="rounded" />
                            </Stack>
                            <Stack direction="column" width="100%" gap={tokens.SizingSpacing150}>
                                <LoadingSkeleton height="36px" width="138px" variant="rounded" />
                                <Stack direction="row" gap={tokens.SizingSpacing400}>
                                    <Stack direction="column" gap={tokens.SizingSpacing150}>
                                        <LoadingSkeleton count={9} height="24px" width="175px" variant="rounded" />
                                    </Stack>
                                    <Stack direction="column" gap={tokens.SizingSpacing150}>
                                        <LoadingSkeleton count={9} height="24px" width="236px" variant="rounded" />
                                    </Stack>
                                </Stack>
                            </Stack>
                            <Stack direction="column" gap={tokens.SizingSpacing150}>
                                <LoadingSkeleton height="36px" width="138px" variant="rounded" />
                                <Stack direction="row" gap={tokens.SizingSpacing400}>
                                    <Stack direction="column" gap={tokens.SizingSpacing150}>
                                        <LoadingSkeleton count={5} height="24px" width="175px" variant="rounded" />
                                    </Stack>
                                    <Stack direction="column" gap={tokens.SizingSpacing150}>
                                        <LoadingSkeleton count={5} height="24px" width="236px" variant="rounded" />
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Stack>
                    </>
                    <>
                        <Stack direction="column" width="100%" gap={tokens.SizingSpacing400}>
                            <LoadingSkeleton height="120px" width="100%" variant="rounded" />
                            {[0, 1].map((section) => (
                                <Stack key={section} direction="column" width="100%" gap={tokens.SizingSpacing200}>
                                    <LoadingSkeleton height="36px" width="140px" variant="rounded" />
                                    {[0, 1].map((key) => (
                                        <Stack
                                            key={`${section}-${key}`}
                                            direction="row"
                                            gap={tokens.SizingSpacing200}
                                            alignItems="center"
                                            justifyContent="space-between"
                                        >
                                            <Stack direction="row" gap={tokens.SizingSpacing300} alignItems="center">
                                                <LoadingSkeleton
                                                    height="36px"
                                                    width="36px"
                                                    sx={{ transform: 'none', borderRadius: '100%' }}
                                                />
                                                <Stack direction="column" gap={tokens.SizingSpacing050}>
                                                    <LoadingSkeleton height="28px" width="150px" variant="rounded" />
                                                    <LoadingSkeleton height="20px" width="300px" variant="rounded" />
                                                </Stack>
                                            </Stack>
                                            <Stack direction="column" gap={tokens.SizingSpacing050} alignItems="flex-end">
                                                <LoadingSkeleton height="20px" width="80px" variant="rounded" />
                                                <LoadingSkeleton height="30px" width="40px" variant="rounded" />
                                            </Stack>
                                        </Stack>
                                    ))}
                                </Stack>
                            ))}
                        </Stack>
                    </>
                </PageRowTemplate>
                <Stack direction="column" gap={tokens.SizingSpacing100}>
                    <LoadingSkeleton height="36px" width="150px" variant="rounded" />
                    <Stack direction="column" gap={tokens.SizingSpacing100}>
                        <LoadingSkeleton count={3} height="32px" width="100%" variant="rounded" />
                    </Stack>
                </Stack>
            </Stack>
        </ClientPortalPageWithSidebarTemplate>
    )
}
